import { SchemaFormInputsRegistry } from "@smallstack/widget-core";
import { DocumentFormInputComponent } from "./document-form-input/document-form-input.component";

export function addDefaultPdfFormInputComponents(schemaFormInputsRegistry: SchemaFormInputsRegistry): void {
  schemaFormInputsRegistry.addWidget("document", DocumentFormInputComponent);
}
